"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconFileEdit = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M5.00557103,1.5 C3.90250696,1.5 3,2.4 3,3.5 L3,19.5 C3,20.6 3.90250696,21.5 5.00557103,21.5 L9.01671309,21.5 L9.01671309,19.6 L19.0445682,9.6 L19.0445682,7.5 L13.0278552,1.5 L5.00557103,1.5 M12.0250696,3 L17.54039,8.5 L12.0250696,8.5 L12.0250696,3 M19.1448468,12.5 C19.0445682,12.5 18.8440111,12.6 18.7437326,12.7 L17.7409471,13.7 L19.8467967,15.8 L20.8495822,14.8 C21.0501393,14.6 21.0501393,14.2 20.8495822,14 L19.545961,12.7 C19.4456825,12.6 19.3454039,12.5 19.1448468,12.5 M17.1392758,14.3 L11.0222841,20.4 L11.0222841,22.5 L13.1281337,22.5 L19.2451253,16.4 L17.1392758,14.3 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconFileEdit')(IconFileEdit);